import { Navigation } from "@/components/Navigation";
import { HeroCarousel } from "@/components/HeroCarousel";
import { PracticeAreas } from "@/components/PracticeAreas";
import { MarqueeText } from "@/components/MarqueeText";
import { Founder } from "@/components/Founder";
import { News } from "@/components/News";
import { Content } from "@/components/Content";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { ScrollProgress } from "@/components/ScrollProgress";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <ScrollProgress />
      <Navigation />
      <main>
        <HeroCarousel />
        <PracticeAreas />
        <MarqueeText />
        <News />
        <Content />
        <Founder />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
